<template>
    <div class="Tracking">
        <div v-if="!!step">
            <div class="text-subtitle1 text-weight-medium mb-0-5">
                {{ $t('wizard.preview.step') }} {{ step.num }}/{{ length }}:
                <span class="text-subtitle1">
                    {{ $t('wizard.preview.select') }} "{{ step.label }}" {{ $t('wizard.preview.column') }}
                </span>
                <span
                    v-if="step.optional"
                    class="text-subtitle1 text-grey-7"
                >
                    ({{ $t('wizard.preview.optional') }})
                </span>
            </div>
            <div class="text-body2">
                {{ step.tooltip }}
            </div>
        </div>
        <div v-else>
            <div class="text-subtitle1 text-weight-medium mb-0-5 text-primary">
                {{ $t('wizard.preview.dataTypesTitle') }}:
            </div>
            <div class="text-body2">
                {{ $t('wizard.preview.relevantAttributesDescription') }}
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'TrackingPreview',
    props: {
        length: VueTypes.number,
        step: VueTypes.shape({
            num: VueTypes.number,
            label: VueTypes.string,
            tooltip: VueTypes.string,
            optional: VueTypes.bool.def(false),
        }).loose,
    },
}
</script>
